/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
 /* tslint:disable */

import * as import0 from './content-records.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/element';
import * as import4 from '../shared/name-resolver.pipe';
import * as import5 from '@angular/core/src/linker/view_utils';
import * as import6 from '@angular/core/src/di/injector';
import * as import7 from '@angular/core/src/linker/view_type';
import * as import8 from '@angular/core/src/change_detection/change_detection';
import * as import9 from '@angular/core/src/linker/element_ref';
import * as import10 from '../shared/config.service';
import * as import11 from '../shared/utils.service';
import * as import12 from '../shared/intl.service';
import * as import13 from '../shared/meta.service';
import * as import14 from '../shared/content.service';
import * as import15 from '@angular/router/src/router_state';
import * as import16 from '@angular/common/src/location/location';
import * as import17 from '@angular/router/src/router';
import * as import18 from '@angular/core/src/metadata/view';
import * as import19 from '@angular/core/src/linker/component_factory';
import * as import20 from '../../../node_modules/@angular/common/src/directives/ng_class.ngfactory';
import * as import21 from '../shared/searchable-contents.component.ngfactory';
import * as import22 from '../../../node_modules/@angular/common/src/directives/ng_switch.ngfactory';
import * as import23 from '../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import24 from '../shared/intl.pipe';
import * as import25 from '@angular/common/src/pipes/number_pipe';
import * as import26 from '../shared/truncate.pipe';
import * as import27 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import28 from '@angular/core/src/change_detection/differs/keyvalue_differs';
import * as import29 from '../shared/search.service';
import * as import30 from '../shared/search-elasticsearch.service';
import * as import31 from '@angular/core/src/linker/template_ref';
import * as import32 from '@angular/core/src/i18n/tokens';
import * as import33 from '@angular/common/src/directives/ng_class';
import * as import34 from '@angular/common/src/directives/ng_switch';
import * as import35 from '@angular/common/src/directives/ng_if';
import * as import36 from '../shared/searchable-contents.component';
import * as import37 from '../shared/loading-indicator.ngfactory';
import * as import38 from '../shared/loading-indicator';
import * as import39 from '../shared/search.component.ngfactory';
import * as import40 from '../shared/search.component';
import * as import41 from './search-facets.component.ngfactory';
import * as import42 from './search-facets.component';
import * as import43 from './search-az.component.ngfactory';
import * as import44 from './search-az.component';
import * as import45 from '../shared/search-filter.component.ngfactory';
import * as import46 from '../shared/search-filter.component';
import * as import47 from './content-records-featured.component.ngfactory';
import * as import48 from '../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import49 from '@angular/common/src/directives/ng_for';
import * as import50 from './content-records-featured.component';
import * as import51 from '@angular/core/src/security';
import * as import52 from '../../../node_modules/ng-lazyload-image/src/lazyload-image.directive.ngfactory';
import * as import53 from '@angular/core/src/zone/ng_zone';
import * as import54 from 'ng-lazyload-image/src/lazyload-image.directive';
import * as import55 from './content-specials.component.ngfactory';
import * as import56 from './content-specials.component';
import * as import57 from '../../../node_modules/ng2-bs-pagination/src/pagination.component.ngfactory';
import * as import58 from 'ng2-bs-pagination/src/pagination.component';
export class Wrapper_ContentRecordsComponent {
  context:import0.ContentRecordsComponent;
  changed:boolean;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any,p5:any,p6:any,p7:any,p8:any,p9:any) {
    this.changed = false;
    this.context = new import0.ContentRecordsComponent(p0,p1,p2,p3,p4,p5,p6,p7,p8,p9);
  }
  detectChangesInInputProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this.changed;
    this.changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  detectChangesInHostProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
}
var renderType_ContentRecordsComponent_Host:import2.RenderComponentType = (null as any);
class _View_ContentRecordsComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import3.AppElement;
  _NameResolverPipe_0_4:import4.NameResolverPipe;
  _ContentRecordsComponent_0_5:Wrapper_ContentRecordsComponent;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordsComponent_Host0,renderType_ContentRecordsComponent_Host,import7.ViewType.HOST,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.selectOrCreateRenderHostElement(this.renderer,'ng-component',import5.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this._appEl_0 = new import3.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = viewFactory_ContentRecordsComponent0(this.viewUtils,this.injector(0),this._appEl_0);
    this._NameResolverPipe_0_4 = new import4.NameResolverPipe();
    this._ContentRecordsComponent_0_5 = new Wrapper_ContentRecordsComponent(this._NameResolverPipe_0_4,new import9.ElementRef(this._el_0),this.parentInjector.get(import10.ConfigService),this.parentInjector.get(import11.UtilsService),this.parentInjector.get(import12.IntlService),this.parentInjector.get(import13.MetaService),this.parentInjector.get(import14.ContentService),this.parentInjector.get(import15.ActivatedRoute),this.parentInjector.get(import16.Location),this.parentInjector.get(import17.Router));
    this._appEl_0.initComponent(this._ContentRecordsComponent_0_5.context,([] as any[]),compView_0);
    compView_0.create(this._ContentRecordsComponent_0_5.context,this.projectableNodes,(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return this._appEl_0;
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import4.NameResolverPipe) && (0 === requestNodeIndex))) { return this._NameResolverPipe_0_4; }
    if (((token === import0.ContentRecordsComponent) && (0 === requestNodeIndex))) { return this._ContentRecordsComponent_0_5.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._ContentRecordsComponent_0_5.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    if (!throwOnChange) { this._ContentRecordsComponent_0_5.context.ngAfterContentChecked(); }
    this._ContentRecordsComponent_0_5.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentRecordsComponent_Host0(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  if ((renderType_ContentRecordsComponent_Host === (null as any))) { (renderType_ContentRecordsComponent_Host = viewUtils.createRenderComponentType('',0,import18.ViewEncapsulation.None,([] as any[]),{})); }
  return new _View_ContentRecordsComponent_Host0(viewUtils,parentInjector,declarationEl);
}
export const ContentRecordsComponentNgFactory:import19.ComponentFactory<import0.ContentRecordsComponent> = new import19.ComponentFactory<import0.ContentRecordsComponent>('ng-component',viewFactory_ContentRecordsComponent_Host0,import0.ContentRecordsComponent);
const styles_ContentRecordsComponent:any[] = ([] as any[]);
var renderType_ContentRecordsComponent:import2.RenderComponentType = (null as any);
class _View_ContentRecordsComponent0 extends import1.AppView<import0.ContentRecordsComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _el_14:any;
  _el_15:any;
  _text_16:any;
  _text_17:any;
  _text_18:any;
  _el_19:any;
  _text_20:any;
  _el_21:any;
  _text_22:any;
  _el_23:any;
  _el_24:any;
  _NgClass_24_3:import20.Wrapper_NgClass;
  _text_25:any;
  _text_26:any;
  _el_27:any;
  _el_28:any;
  _NgClass_28_3:import20.Wrapper_NgClass;
  _text_29:any;
  _text_30:any;
  _el_31:any;
  _el_32:any;
  _NgClass_32_3:import20.Wrapper_NgClass;
  _text_33:any;
  _text_34:any;
  _el_35:any;
  _el_36:any;
  _NgClass_36_3:import20.Wrapper_NgClass;
  _text_37:any;
  _text_38:any;
  _text_39:any;
  _text_40:any;
  _text_41:any;
  _text_42:any;
  _text_43:any;
  _text_44:any;
  _el_45:any;
  _SearchableContentsComponent_45_3:import21.Wrapper_SearchableContentsComponent;
  _text_46:any;
  _el_47:any;
  _NgSwitch_47_3:import22.Wrapper_NgSwitch;
  _text_48:any;
  _el_49:any;
  _text_50:any;
  _text_51:any;
  _anchor_52:any;
  /*private*/ _appEl_52:import3.AppElement;
  _TemplateRef_52_5:any;
  _NgSwitchCase_52_6:import22.Wrapper_NgSwitchCase;
  _text_53:any;
  _text_54:any;
  _anchor_55:any;
  /*private*/ _appEl_55:import3.AppElement;
  _TemplateRef_55_5:any;
  _NgIf_55_6:import23.Wrapper_NgIf;
  _text_56:any;
  _text_57:any;
  _text_58:any;
  _anchor_59:any;
  /*private*/ _appEl_59:import3.AppElement;
  _TemplateRef_59_5:any;
  _NgSwitchCase_59_6:import22.Wrapper_NgSwitchCase;
  _text_60:any;
  _text_61:any;
  _text_62:any;
  _text_63:any;
  /*private*/ _expr_79:any;
  _pipe_intl_0:import24.IntlPipe;
  _pipe_intl_0_0:any;
  _map_82:any;
  /*private*/ _expr_83:any;
  _pipe_intl_0_1:any;
  _map_85:any;
  /*private*/ _expr_86:any;
  _pipe_intl_0_2:any;
  _map_88:any;
  /*private*/ _expr_89:any;
  _pipe_intl_0_3:any;
  _map_91:any;
  /*private*/ _expr_92:any;
  _pipe_intl_0_4:any;
  _pipe_number_1:import25.DecimalPipe;
  _pipe_truncate_2:import26.TruncatePipe;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordsComponent0,renderType_ContentRecordsComponent,import7.ViewType.COMPONENT,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_79 = import8.UNINITIALIZED;
    this._map_82 = import5.pureProxy1((p0:any):{[key: string]:any} => {
      return {'breadcrumb-active': p0};
    });
    this._expr_83 = import8.UNINITIALIZED;
    this._map_85 = import5.pureProxy1((p0:any):{[key: string]:any} => {
      return {'breadcrumb-active': p0};
    });
    this._expr_86 = import8.UNINITIALIZED;
    this._map_88 = import5.pureProxy1((p0:any):{[key: string]:any} => {
      return {'breadcrumb-active': p0};
    });
    this._expr_89 = import8.UNINITIALIZED;
    this._map_91 = import5.pureProxy1((p0:any):{[key: string]:any} => {
      return {'breadcrumb-active': p0};
    });
    this._expr_92 = import8.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    const parentRenderNode:any = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
    this._el_0 = import5.createRenderElement(this.renderer,parentRenderNode,'section',new import5.InlineArray2(2,'class','page-title-pull-top page-title parallax3 parallax-fix'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'div',new import5.InlineArray2(2,'class','opacity-light bg-dark-gray'),(null as any));
    this._text_3 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_4 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._text_5 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._el_6 = import5.createRenderElement(this.renderer,parentRenderNode,'section',new import5.InlineArray2(2,'class','page-title page-title-small bg-gray'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n    ',(null as any));
    this._el_8 = import5.createRenderElement(this.renderer,this._el_6,'div',new import5.InlineArray2(2,'class','container'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n        ',(null as any));
    this._el_10 = import5.createRenderElement(this.renderer,this._el_8,'div',new import5.InlineArray2(2,'class','row'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'\n            ',(null as any));
    this._el_12 = import5.createRenderElement(this.renderer,this._el_10,'div',new import5.InlineArray2(2,'class','hidden-md hidden-sm hidden-xs col-md-2 col-sm-12'),(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'\n                ',(null as any));
    this._el_14 = import5.createRenderElement(this.renderer,this._el_12,'h1',new import5.InlineArray2(2,'class','black-text'),(null as any));
    this._el_15 = import5.createRenderElement(this.renderer,this._el_14,'a',new import5.InlineArray2(2,'class','pointer'),(null as any));
    this._text_16 = this.renderer.createText(this._el_15,'',(null as any));
    this._text_17 = this.renderer.createText(this._el_12,'\n            ',(null as any));
    this._text_18 = this.renderer.createText(this._el_10,'\n            ',(null as any));
    this._el_19 = import5.createRenderElement(this.renderer,this._el_10,'div',new import5.InlineArray2(2,'class','col-md-10 col-sm-12 breadcrumb text-uppercase'),(null as any));
    this._text_20 = this.renderer.createText(this._el_19,'\n                ',(null as any));
    this._el_21 = import5.createRenderElement(this.renderer,this._el_19,'ul',new import5.InlineArray2(2,'class','breadcrumb-sub'),(null as any));
    this._text_22 = this.renderer.createText(this._el_21,'\n                    ',(null as any));
    this._el_23 = import5.createRenderElement(this.renderer,this._el_21,'li',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._el_24 = import5.createRenderElement(this.renderer,this._el_23,'a',new import5.InlineArray2(2,'class','pointer'),(null as any));
    this._NgClass_24_3 = new import20.Wrapper_NgClass(this.parentInjector.get(import27.IterableDiffers),this.parentInjector.get(import28.KeyValueDiffers),new import9.ElementRef(this._el_24),this.renderer);
    this._text_25 = this.renderer.createText(this._el_24,'',(null as any));
    this._text_26 = this.renderer.createText(this._el_21,'\n                    ',(null as any));
    this._el_27 = import5.createRenderElement(this.renderer,this._el_21,'li',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._el_28 = import5.createRenderElement(this.renderer,this._el_27,'a',new import5.InlineArray2(2,'class','pointer'),(null as any));
    this._NgClass_28_3 = new import20.Wrapper_NgClass(this.parentInjector.get(import27.IterableDiffers),this.parentInjector.get(import28.KeyValueDiffers),new import9.ElementRef(this._el_28),this.renderer);
    this._text_29 = this.renderer.createText(this._el_28,'',(null as any));
    this._text_30 = this.renderer.createText(this._el_21,'\n                    ',(null as any));
    this._el_31 = import5.createRenderElement(this.renderer,this._el_21,'li',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._el_32 = import5.createRenderElement(this.renderer,this._el_31,'a',new import5.InlineArray2(2,'class','pointer'),(null as any));
    this._NgClass_32_3 = new import20.Wrapper_NgClass(this.parentInjector.get(import27.IterableDiffers),this.parentInjector.get(import28.KeyValueDiffers),new import9.ElementRef(this._el_32),this.renderer);
    this._text_33 = this.renderer.createText(this._el_32,'',(null as any));
    this._text_34 = this.renderer.createText(this._el_21,'\n                    ',(null as any));
    this._el_35 = import5.createRenderElement(this.renderer,this._el_21,'li',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._el_36 = import5.createRenderElement(this.renderer,this._el_35,'a',new import5.InlineArray2(2,'class','pointer'),(null as any));
    this._NgClass_36_3 = new import20.Wrapper_NgClass(this.parentInjector.get(import27.IterableDiffers),this.parentInjector.get(import28.KeyValueDiffers),new import9.ElementRef(this._el_36),this.renderer);
    this._text_37 = this.renderer.createText(this._el_36,'',(null as any));
    this._text_38 = this.renderer.createText(this._el_21,'\n                ',(null as any));
    this._text_39 = this.renderer.createText(this._el_19,'\n            ',(null as any));
    this._text_40 = this.renderer.createText(this._el_10,'\n        ',(null as any));
    this._text_41 = this.renderer.createText(this._el_8,'\n    ',(null as any));
    this._text_42 = this.renderer.createText(this._el_6,'\n',(null as any));
    this._text_43 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._text_44 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._el_45 = import5.createRenderElement(this.renderer,parentRenderNode,'section',new import5.InlineArray8(8,'class','page-pull-top','context','record','id','content-start','searchable-contents',''),(null as any));
    this._SearchableContentsComponent_45_3 = new import21.Wrapper_SearchableContentsComponent(this.parentInjector.get(import14.ContentService),this.parentInjector.get(import29.SearchService),this.parentInjector.get(import11.UtilsService),this.parentInjector.get(import15.ActivatedRoute),this.parentInjector.get(import17.Router),this.parentInjector.get(import30.ElasticSearchService));
    this._text_46 = this.renderer.createText(this._el_45,'\n\n  ',(null as any));
    this._el_47 = import5.createRenderElement(this.renderer,this._el_45,'div',new import5.InlineArray2(2,'class','container'),(null as any));
    this._NgSwitch_47_3 = new import22.Wrapper_NgSwitch();
    this._text_48 = this.renderer.createText(this._el_47,'\n    ',(null as any));
    this._el_49 = import5.createRenderElement(this.renderer,this._el_47,'div',new import5.InlineArray2(2,'class','row'),(null as any));
    this._text_50 = this.renderer.createText(this._el_49,'\n\n      ',(null as any));
    this._text_51 = this.renderer.createText(this._el_49,'\n      ',(null as any));
    this._anchor_52 = this.renderer.createTemplateAnchor(this._el_49,(null as any));
    this._appEl_52 = new import3.AppElement(52,49,this,this._anchor_52);
    this._TemplateRef_52_5 = new import31.TemplateRef_(this._appEl_52,viewFactory_ContentRecordsComponent1);
    this._NgSwitchCase_52_6 = new import22.Wrapper_NgSwitchCase(this._appEl_52.vcRef,this._TemplateRef_52_5,this._NgSwitch_47_3.context);
    this._text_53 = this.renderer.createText(this._el_49,'\n\n      ',(null as any));
    this._text_54 = this.renderer.createText(this._el_49,'\n      ',(null as any));
    this._anchor_55 = this.renderer.createTemplateAnchor(this._el_49,(null as any));
    this._appEl_55 = new import3.AppElement(55,49,this,this._anchor_55);
    this._TemplateRef_55_5 = new import31.TemplateRef_(this._appEl_55,viewFactory_ContentRecordsComponent2);
    this._NgIf_55_6 = new import23.Wrapper_NgIf(this._appEl_55.vcRef,this._TemplateRef_55_5);
    this._text_56 = this.renderer.createText(this._el_49,'\n      ',(null as any));
    this._text_57 = this.renderer.createText(this._el_49,'\n\n      ',(null as any));
    this._text_58 = this.renderer.createText(this._el_49,'\n      ',(null as any));
    this._anchor_59 = this.renderer.createTemplateAnchor(this._el_49,(null as any));
    this._appEl_59 = new import3.AppElement(59,49,this,this._anchor_59);
    this._TemplateRef_59_5 = new import31.TemplateRef_(this._appEl_59,viewFactory_ContentRecordsComponent4);
    this._NgSwitchCase_59_6 = new import22.Wrapper_NgSwitchCase(this._appEl_59.vcRef,this._TemplateRef_59_5,this._NgSwitch_47_3.context);
    this._text_60 = this.renderer.createText(this._el_49,'\n    ',(null as any));
    this._text_61 = this.renderer.createText(this._el_47,'\n  ',(null as any));
    this._text_62 = this.renderer.createText(this._el_45,'\n',(null as any));
    this._text_63 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_15,'click',this.eventHandler(this._handle_click_15_0.bind(this)));
    this._pipe_intl_0 = new import24.IntlPipe();
    this._pipe_intl_0_0 = import5.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
    var disposable_1:Function = this.renderer.listen(this._el_24,'click',this.eventHandler(this._handle_click_24_0.bind(this)));
    this._pipe_intl_0_1 = import5.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
    var disposable_2:Function = this.renderer.listen(this._el_28,'click',this.eventHandler(this._handle_click_28_0.bind(this)));
    this._pipe_intl_0_2 = import5.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
    var disposable_3:Function = this.renderer.listen(this._el_32,'click',this.eventHandler(this._handle_click_32_0.bind(this)));
    this._pipe_intl_0_3 = import5.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
    var disposable_4:Function = this.renderer.listen(this._el_36,'click',this.eventHandler(this._handle_click_36_0.bind(this)));
    this._pipe_intl_0_4 = import5.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
    this._pipe_number_1 = new import25.DecimalPipe(this.parentInjector.get(import32.LOCALE_ID));
    this._pipe_truncate_2 = new import26.TruncatePipe();
    this.init(([] as any[]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._el_14,
      this._el_15,
      this._text_16,
      this._text_17,
      this._text_18,
      this._el_19,
      this._text_20,
      this._el_21,
      this._text_22,
      this._el_23,
      this._el_24,
      this._text_25,
      this._text_26,
      this._el_27,
      this._el_28,
      this._text_29,
      this._text_30,
      this._el_31,
      this._el_32,
      this._text_33,
      this._text_34,
      this._el_35,
      this._el_36,
      this._text_37,
      this._text_38,
      this._text_39,
      this._text_40,
      this._text_41,
      this._text_42,
      this._text_43,
      this._text_44,
      this._el_45,
      this._text_46,
      this._el_47,
      this._text_48,
      this._el_49,
      this._text_50,
      this._text_51,
      this._anchor_52,
      this._text_53,
      this._text_54,
      this._anchor_55,
      this._text_56,
      this._text_57,
      this._text_58,
      this._anchor_59,
      this._text_60,
      this._text_61,
      this._text_62,
      this._text_63
    ]
    ,[
      disposable_0,
      disposable_1,
      disposable_2,
      disposable_3,
      disposable_4
    ]
    ,([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import33.NgClass) && ((24 <= requestNodeIndex) && (requestNodeIndex <= 25)))) { return this._NgClass_24_3.context; }
    if (((token === import33.NgClass) && ((28 <= requestNodeIndex) && (requestNodeIndex <= 29)))) { return this._NgClass_28_3.context; }
    if (((token === import33.NgClass) && ((32 <= requestNodeIndex) && (requestNodeIndex <= 33)))) { return this._NgClass_32_3.context; }
    if (((token === import33.NgClass) && ((36 <= requestNodeIndex) && (requestNodeIndex <= 37)))) { return this._NgClass_36_3.context; }
    if (((token === import31.TemplateRef) && (52 === requestNodeIndex))) { return this._TemplateRef_52_5; }
    if (((token === import34.NgSwitchCase) && (52 === requestNodeIndex))) { return this._NgSwitchCase_52_6.context; }
    if (((token === import31.TemplateRef) && (55 === requestNodeIndex))) { return this._TemplateRef_55_5; }
    if (((token === import35.NgIf) && (55 === requestNodeIndex))) { return this._NgIf_55_6.context; }
    if (((token === import31.TemplateRef) && (59 === requestNodeIndex))) { return this._TemplateRef_59_5; }
    if (((token === import34.NgSwitchCase) && (59 === requestNodeIndex))) { return this._NgSwitchCase_59_6.context; }
    if (((token === import34.NgSwitch) && ((47 <= requestNodeIndex) && (requestNodeIndex <= 61)))) { return this._NgSwitch_47_3.context; }
    if (((token === import36.SearchableContentsComponent) && ((45 <= requestNodeIndex) && (requestNodeIndex <= 62)))) { return this._SearchableContentsComponent_45_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import8.ValueUnwrapper();
    const currVal_24_0_0:any = 'pointer';
    this._NgClass_24_3.check_klass(currVal_24_0_0,throwOnChange,false);
    const currVal_24_0_1:any = this._map_82((!this.context.entryType && !this.context.hasFilter));
    this._NgClass_24_3.check_ngClass(currVal_24_0_1,throwOnChange,false);
    this._NgClass_24_3.detectChangesInInputProps(this,this._el_24,throwOnChange);
    const currVal_28_0_0:any = 'pointer';
    this._NgClass_28_3.check_klass(currVal_28_0_0,throwOnChange,false);
    const currVal_28_0_1:any = this._map_85((this.context.entryType == 'reissue'));
    this._NgClass_28_3.check_ngClass(currVal_28_0_1,throwOnChange,false);
    this._NgClass_28_3.detectChangesInInputProps(this,this._el_28,throwOnChange);
    const currVal_32_0_0:any = 'pointer';
    this._NgClass_32_3.check_klass(currVal_32_0_0,throwOnChange,false);
    const currVal_32_0_1:any = this._map_88((this.context.entryType == 'production'));
    this._NgClass_32_3.check_ngClass(currVal_32_0_1,throwOnChange,false);
    this._NgClass_32_3.detectChangesInInputProps(this,this._el_32,throwOnChange);
    const currVal_36_0_0:any = 'pointer';
    this._NgClass_36_3.check_klass(currVal_36_0_0,throwOnChange,false);
    const currVal_36_0_1:any = this._map_91((this.context.entryType == 'special'));
    this._NgClass_36_3.check_ngClass(currVal_36_0_1,throwOnChange,false);
    this._NgClass_36_3.detectChangesInInputProps(this,this._el_36,throwOnChange);
    const currVal_45_0_0:any = 'record';
    this._SearchableContentsComponent_45_3.check_context(currVal_45_0_0,throwOnChange,false);
    const currVal_45_0_1:any = this.context.pageSize;
    this._SearchableContentsComponent_45_3.check_pageSize(currVal_45_0_1,throwOnChange,false);
    const currVal_45_0_2:any = true;
    this._SearchableContentsComponent_45_3.check_active(currVal_45_0_2,throwOnChange,false);
    this._SearchableContentsComponent_45_3.detectChangesInInputProps(this,this._el_45,throwOnChange);
    const currVal_47_0_0:any = this._SearchableContentsComponent_45_3.context.loading;
    this._NgSwitch_47_3.check_ngSwitch(currVal_47_0_0,throwOnChange,false);
    this._NgSwitch_47_3.detectChangesInInputProps(this,this._el_47,throwOnChange);
    const currVal_52_0_0:any = true;
    this._NgSwitchCase_52_6.check_ngSwitchCase(currVal_52_0_0,throwOnChange,false);
    this._NgSwitchCase_52_6.detectChangesInInputProps(this,this._anchor_52,throwOnChange);
    const currVal_55_0_0:any = this.context.hasFilter;
    this._NgIf_55_6.check_ngIf(currVal_55_0_0,throwOnChange,false);
    this._NgIf_55_6.detectChangesInInputProps(this,this._anchor_55,throwOnChange);
    const currVal_59_0_0:any = false;
    this._NgSwitchCase_59_6.check_ngSwitchCase(currVal_59_0_0,throwOnChange,false);
    this._NgSwitchCase_59_6.detectChangesInInputProps(this,this._anchor_59,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_79:any = import5.interpolate(1,'\n                ',valUnwrapper.unwrap(import5.castByValue(this._pipe_intl_0_0,this._pipe_intl_0.transform)(((this.context.intl.data == (null as any))? (null as any): this.context.intl.data.COMMON.MENU.CATALOGUE),this.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange,this._expr_79,currVal_79))) {
      this.renderer.setText(this._text_16,currVal_79);
      this._expr_79 = currVal_79;
    }
    this._NgClass_24_3.detectChangesInHostProps(this,this._el_24,throwOnChange);
    valUnwrapper.reset();
    const currVal_83:any = import5.interpolate(1,'\n                      ',valUnwrapper.unwrap(import5.castByValue(this._pipe_intl_0_1,this._pipe_intl_0.transform)(((this.context.intl.data == (null as any))? (null as any): this.context.intl.data.COMMON.MENU.CATALOGUE.ALL),this.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange,this._expr_83,currVal_83))) {
      this.renderer.setText(this._text_25,currVal_83);
      this._expr_83 = currVal_83;
    }
    this._NgClass_28_3.detectChangesInHostProps(this,this._el_28,throwOnChange);
    valUnwrapper.reset();
    const currVal_86:any = import5.interpolate(1,'\n                      ',valUnwrapper.unwrap(import5.castByValue(this._pipe_intl_0_2,this._pipe_intl_0.transform)(((this.context.intl.data == (null as any))? (null as any): this.context.intl.data.COMMON.MENU.CATALOGUE.REISSUE),this.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange,this._expr_86,currVal_86))) {
      this.renderer.setText(this._text_29,currVal_86);
      this._expr_86 = currVal_86;
    }
    this._NgClass_32_3.detectChangesInHostProps(this,this._el_32,throwOnChange);
    valUnwrapper.reset();
    const currVal_89:any = import5.interpolate(1,'\n                      ',valUnwrapper.unwrap(import5.castByValue(this._pipe_intl_0_3,this._pipe_intl_0.transform)(((this.context.intl.data == (null as any))? (null as any): this.context.intl.data.COMMON.MENU.CATALOGUE.PRODUCTION),this.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange,this._expr_89,currVal_89))) {
      this.renderer.setText(this._text_33,currVal_89);
      this._expr_89 = currVal_89;
    }
    this._NgClass_36_3.detectChangesInHostProps(this,this._el_36,throwOnChange);
    valUnwrapper.reset();
    const currVal_92:any = import5.interpolate(1,'\n                      ',valUnwrapper.unwrap(import5.castByValue(this._pipe_intl_0_4,this._pipe_intl_0.transform)(((this.context.intl.data == (null as any))? (null as any): this.context.intl.data.COMMON.MENU.CATALOGUE.SPECIAL),this.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange,this._expr_92,currVal_92))) {
      this.renderer.setText(this._text_37,currVal_92);
      this._expr_92 = currVal_92;
    }
    this._SearchableContentsComponent_45_3.detectChangesInHostProps(this,this._el_45,throwOnChange);
    this._NgSwitch_47_3.detectChangesInHostProps(this,this._el_47,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_15_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_15_0:any = ((<any>this.context.utils.lLink('catalogue',this.context.currentLanguage)) !== false);
    return (true && pd_15_0);
  }
  private _handle_click_24_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_24_0:any = ((<any>this.context.utils.lLink('catalogue',this.context.currentLanguage)) !== false);
    return (true && pd_24_0);
  }
  private _handle_click_28_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_28_0:any = ((<any>this.context.utils.lLink('catalogue/reissue',this.context.currentLanguage)) !== false);
    return (true && pd_28_0);
  }
  private _handle_click_32_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_32_0:any = ((<any>this.context.utils.lLink('catalogue/production',this.context.currentLanguage)) !== false);
    return (true && pd_32_0);
  }
  private _handle_click_36_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_36_0:any = ((<any>this.context.utils.lLink('catalogue/special',this.context.currentLanguage)) !== false);
    return (true && pd_36_0);
  }
}
export function viewFactory_ContentRecordsComponent0(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<import0.ContentRecordsComponent> {
  if ((renderType_ContentRecordsComponent === (null as any))) { (renderType_ContentRecordsComponent = viewUtils.createRenderComponentType('',0,import18.ViewEncapsulation.None,styles_ContentRecordsComponent,{})); }
  return new _View_ContentRecordsComponent0(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordsComponent1 extends import1.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import3.AppElement;
  _LoadingIndicator_0_4:import37.Wrapper_LoadingIndicator;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordsComponent1,renderType_ContentRecordsComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'loading-indicator',new import5.InlineArray2(2,'color','#B6B6B6'),(null as any));
    this._appEl_0 = new import3.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = import37.viewFactory_LoadingIndicator0(this.viewUtils,this.injector(0),this._appEl_0);
    this._LoadingIndicator_0_4 = new import37.Wrapper_LoadingIndicator();
    this._appEl_0.initComponent(this._LoadingIndicator_0_4.context,([] as any[]),compView_0);
    compView_0.create(this._LoadingIndicator_0_4.context,([] as any[]),(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import38.LoadingIndicator) && (0 === requestNodeIndex))) { return this._LoadingIndicator_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = '#B6B6B6';
    this._LoadingIndicator_0_4.check_color(currVal_0_0_0,throwOnChange,false);
    this._LoadingIndicator_0_4.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._LoadingIndicator_0_4.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentRecordsComponent1(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordsComponent1(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordsComponent2 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  /*private*/ _appEl_2:import3.AppElement;
  _SearchComponent_2_4:import39.Wrapper_SearchComponent;
  _text_3:any;
  _text_4:any;
  _anchor_5:any;
  /*private*/ _appEl_5:import3.AppElement;
  _TemplateRef_5_5:any;
  _NgSwitchCase_5_6:import22.Wrapper_NgSwitchCase;
  _text_6:any;
  _pipe_intl_0_5:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordsComponent2,renderType_ContentRecordsComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'div',new import5.InlineArray2(2,'class','col-md-3 col-sm-4 sidebar'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'search',new import5.InlineArray4(4,'scrollOnClick','#content-start','target','/catalogue'),(null as any));
    this._appEl_2 = new import3.AppElement(2,0,this,this._el_2);
    var compView_2:any = import39.viewFactory_SearchComponent0(this.viewUtils,this.injector(2),this._appEl_2);
    this._SearchComponent_2_4 = new import39.Wrapper_SearchComponent(this.parent.parentInjector.get(import11.UtilsService),this.parent.parentInjector.get(import29.SearchService),this.parent.parentInjector.get(import30.ElasticSearchService),this.parent.parentInjector.get(import15.ActivatedRoute),this.parent.parentInjector.get(import17.Router));
    this._appEl_2.initComponent(this._SearchComponent_2_4.context,([] as any[]),compView_2);
    this._text_3 = this.renderer.createText((null as any),'\n        ',(null as any));
    compView_2.create(this._SearchComponent_2_4.context,([] as any[]),(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n\n        ',(null as any));
    this._anchor_5 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_5 = new import3.AppElement(5,0,this,this._anchor_5);
    this._TemplateRef_5_5 = new import31.TemplateRef_(this._appEl_5,viewFactory_ContentRecordsComponent3);
    this._NgSwitchCase_5_6 = new import22.Wrapper_NgSwitchCase(this._appEl_5.vcRef,this._TemplateRef_5_5,(<_View_ContentRecordsComponent0>this.parent)._NgSwitch_47_3.context);
    this._text_6 = this.renderer.createText(this._el_0,'\n\n      ',(null as any));
    this._pipe_intl_0_5 = import5.pureProxy2((<_View_ContentRecordsComponent0>this.parent)._pipe_intl_0.transform.bind((<_View_ContentRecordsComponent0>this.parent)._pipe_intl_0));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._anchor_5,
      this._text_6
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import40.SearchComponent) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 3)))) { return this._SearchComponent_2_4.context; }
    if (((token === import31.TemplateRef) && (5 === requestNodeIndex))) { return this._TemplateRef_5_5; }
    if (((token === import34.NgSwitchCase) && (5 === requestNodeIndex))) { return this._NgSwitchCase_5_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import8.ValueUnwrapper();
    const currVal_2_0_0:any = ((this.parent.context.config.data == (null as any))? (null as any): this.parent.context.config.data.CATALOGUE.SEARCH.SUGGESTIONS.ORDER);
    this._SearchComponent_2_4.check_order(currVal_2_0_0,throwOnChange,false);
    const currVal_2_0_1:any = '#content-start';
    this._SearchComponent_2_4.check_scrollOnClick(currVal_2_0_1,throwOnChange,false);
    const currVal_2_0_2:any = '/catalogue';
    this._SearchComponent_2_4.check_target(currVal_2_0_2,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_2_0_3:any = import5.interpolate(1,'',valUnwrapper.unwrap(import5.castByValue(this._pipe_intl_0_5,(<_View_ContentRecordsComponent0>this.parent)._pipe_intl_0.transform)(((this.parent.context.intl.data == (null as any))? (null as any): this.parent.context.intl.data.CATALOGUE.SEARCH),this.parent.context.currentLanguage)),'');
    this._SearchComponent_2_4.check_placeholder(currVal_2_0_3,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_2_0_4:any = this.parent.context.currentLanguage;
    this._SearchComponent_2_4.check_language(currVal_2_0_4,throwOnChange,false);
    const currVal_2_0_5:any = ((this.parent.context.intl.data == (null as any))? (null as any): this.parent.context.intl.data.COMMON.TAXONOMY);
    this._SearchComponent_2_4.check_labels(currVal_2_0_5,throwOnChange,false);
    this._SearchComponent_2_4.detectChangesInInputProps(this,this._el_2,throwOnChange);
    const currVal_5_0_0:any = false;
    this._NgSwitchCase_5_6.check_ngSwitchCase(currVal_5_0_0,throwOnChange,false);
    this._NgSwitchCase_5_6.detectChangesInInputProps(this,this._anchor_5,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._SearchComponent_2_4.detectChangesInHostProps(this,this._el_2,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentRecordsComponent2(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordsComponent2(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordsComponent3 extends import1.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import3.AppElement;
  _SearchFacetsComponent_0_4:import41.Wrapper_SearchFacetsComponent;
  _text_1:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordsComponent3,renderType_ContentRecordsComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'search-facets',new import5.InlineArray4(4,'class','hidden-xs','target','/catalogue'),(null as any));
    this._appEl_0 = new import3.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = import41.viewFactory_SearchFacetsComponent0(this.viewUtils,this.injector(0),this._appEl_0);
    this._SearchFacetsComponent_0_4 = new import41.Wrapper_SearchFacetsComponent(this.parent.parent.parentInjector.get(import11.UtilsService),this.parent.parent.parentInjector.get(import15.ActivatedRoute),this.parent.parent.parentInjector.get(import17.Router),this.parent.parent.parentInjector.get(import30.ElasticSearchService));
    this._appEl_0.initComponent(this._SearchFacetsComponent_0_4.context,([] as any[]),compView_0);
    this._text_1 = this.renderer.createText((null as any),'\n        ',(null as any));
    compView_0.create(this._SearchFacetsComponent_0_4.context,([] as any[]),(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_0,'onFilter',this.eventHandler(this._handle_onFilter_0_0.bind(this)));
    const subscription_0:any = this._SearchFacetsComponent_0_4.context.onFilter.subscribe(this.eventHandler(this._handle_onFilter_0_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1
    ]
    ,[disposable_0],[subscription_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import42.SearchFacetsComponent) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._SearchFacetsComponent_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = (<_View_ContentRecordsComponent0>this.parent.parent)._SearchableContentsComponent_45_3.context.esAggregations;
    this._SearchFacetsComponent_0_4.check_esAggregations(currVal_0_0_0,throwOnChange,false);
    const currVal_0_0_1:any = (<_View_ContentRecordsComponent0>this.parent.parent)._SearchableContentsComponent_45_3.context.aggFields.record;
    this._SearchFacetsComponent_0_4.check_fields(currVal_0_0_1,throwOnChange,false);
    const currVal_0_0_2:any = (<_View_ContentRecordsComponent0>this.parent.parent)._SearchableContentsComponent_45_3.context.esFilters;
    this._SearchFacetsComponent_0_4.check_esFilters(currVal_0_0_2,throwOnChange,false);
    const currVal_0_0_3:any = ((this.parent.parent.context.intl.data == (null as any))? (null as any): this.parent.parent.context.intl.data.COMMON.TAXONOMY);
    this._SearchFacetsComponent_0_4.check_labels(currVal_0_0_3,throwOnChange,false);
    const currVal_0_0_4:any = this.parent.parent.context.currentLanguage;
    this._SearchFacetsComponent_0_4.check_language(currVal_0_0_4,throwOnChange,false);
    const currVal_0_0_5:any = '/catalogue';
    this._SearchFacetsComponent_0_4.check_target(currVal_0_0_5,throwOnChange,false);
    this._SearchFacetsComponent_0_4.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._SearchFacetsComponent_0_4.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_onFilter_0_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_0_0:any = ((<any>(<_View_ContentRecordsComponent0>this.parent.parent)._SearchableContentsComponent_45_3.context.searchCallBack($event)) !== false);
    return (true && pd_0_0);
  }
}
function viewFactory_ContentRecordsComponent3(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordsComponent3(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordsComponent4 extends import1.AppView<any> {
  _el_0:any;
  _NgClass_0_3:import20.Wrapper_NgClass;
  _text_1:any;
  _text_2:any;
  _el_3:any;
  _NgClass_3_3:import20.Wrapper_NgClass;
  _text_4:any;
  _text_5:any;
  _anchor_6:any;
  /*private*/ _appEl_6:import3.AppElement;
  _TemplateRef_6_5:any;
  _NgIf_6_6:import23.Wrapper_NgIf;
  _text_7:any;
  _text_8:any;
  _el_9:any;
  _NgClass_9_3:import20.Wrapper_NgClass;
  _text_10:any;
  _text_11:any;
  _el_12:any;
  /*private*/ _appEl_12:import3.AppElement;
  _NgClass_12_4:import20.Wrapper_NgClass;
  _SearchAZComponent_12_5:import43.Wrapper_SearchAZComponent;
  _text_13:any;
  _text_14:any;
  _text_15:any;
  _text_16:any;
  _anchor_17:any;
  /*private*/ _appEl_17:import3.AppElement;
  _TemplateRef_17_5:any;
  _NgIf_17_6:import23.Wrapper_NgIf;
  _text_18:any;
  _anchor_19:any;
  /*private*/ _appEl_19:import3.AppElement;
  _TemplateRef_19_5:any;
  _NgIf_19_6:import23.Wrapper_NgIf;
  _text_20:any;
  _text_21:any;
  _anchor_22:any;
  /*private*/ _appEl_22:import3.AppElement;
  _TemplateRef_22_5:any;
  _NgIf_22_6:import23.Wrapper_NgIf;
  _text_23:any;
  _text_24:any;
  _text_25:any;
  _text_26:any;
  _text_27:any;
  _anchor_28:any;
  /*private*/ _appEl_28:import3.AppElement;
  _TemplateRef_28_5:any;
  _NgIf_28_6:import23.Wrapper_NgIf;
  _text_29:any;
  _text_30:any;
  _anchor_31:any;
  /*private*/ _appEl_31:import3.AppElement;
  _TemplateRef_31_5:any;
  _NgIf_31_6:import23.Wrapper_NgIf;
  _text_32:any;
  _text_33:any;
  _anchor_34:any;
  /*private*/ _appEl_34:import3.AppElement;
  _TemplateRef_34_5:any;
  _NgIf_34_6:import23.Wrapper_NgIf;
  _text_35:any;
  _text_36:any;
  _anchor_37:any;
  /*private*/ _appEl_37:import3.AppElement;
  _TemplateRef_37_5:any;
  _NgSwitchCase_37_6:import22.Wrapper_NgSwitchCase;
  _text_38:any;
  _text_39:any;
  _text_40:any;
  _text_41:any;
  _map_72:any;
  _map_73:any;
  _map_74:any;
  _map_75:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordsComponent4,renderType_ContentRecordsComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._map_72 = import5.pureProxy2((p0:any,p1:any):{[key: string]:any} => {
      return {
        'col-md-9 col-sm-8': p0,
        'col-md-12': p1
      }
      ;
    });
    this._map_73 = import5.pureProxy2((p0:any,p1:any):{[key: string]:any} => {
      return {
        'shorting-filter': p0,
        'shorting-nofilter': p1
      }
      ;
    });
    this._map_74 = import5.pureProxy1((p0:any):{[key: string]:any} => {
      return {'col-lg-9 col-md-8 col-sm-7': p0};
    });
    this._map_75 = import5.pureProxy1((p0:any):{[key: string]:any} => {
      return {'search-az-nofilter': p0};
    });
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'div',new import5.InlineArray2(2,'class','catalogue-content col-md-offset-1'),(null as any));
    this._NgClass_0_3 = new import20.Wrapper_NgClass(this.parent.parentInjector.get(import27.IterableDiffers),this.parent.parentInjector.get(import28.KeyValueDiffers),new import9.ElementRef(this._el_0),this.renderer);
    this._text_1 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._text_2 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._el_3 = import5.createRenderElement(this.renderer,this._el_0,'div',new import5.InlineArray2(2,'class','shorting clearfix xs-no-margin col-xs-12'),(null as any));
    this._NgClass_3_3 = new import20.Wrapper_NgClass(this.parent.parentInjector.get(import27.IterableDiffers),this.parent.parentInjector.get(import28.KeyValueDiffers),new import9.ElementRef(this._el_3),this.renderer);
    this._text_4 = this.renderer.createText(this._el_3,'\n          \n          ',(null as any));
    this._text_5 = this.renderer.createText(this._el_3,'\n          ',(null as any));
    this._anchor_6 = this.renderer.createTemplateAnchor(this._el_3,(null as any));
    this._appEl_6 = new import3.AppElement(6,3,this,this._anchor_6);
    this._TemplateRef_6_5 = new import31.TemplateRef_(this._appEl_6,viewFactory_ContentRecordsComponent5);
    this._NgIf_6_6 = new import23.Wrapper_NgIf(this._appEl_6.vcRef,this._TemplateRef_6_5);
    this._text_7 = this.renderer.createText(this._el_3,'\n\n          ',(null as any));
    this._text_8 = this.renderer.createText(this._el_3,' \n          ',(null as any));
    this._el_9 = import5.createRenderElement(this.renderer,this._el_3,'div',new import5.InlineArray2(2,'class','search-tools-container col-xs-12 grid-nav'),(null as any));
    this._NgClass_9_3 = new import20.Wrapper_NgClass(this.parent.parentInjector.get(import27.IterableDiffers),this.parent.parentInjector.get(import28.KeyValueDiffers),new import9.ElementRef(this._el_9),this.renderer);
    this._text_10 = this.renderer.createText(this._el_9,'\n\n            ',(null as any));
    this._text_11 = this.renderer.createText(this._el_9,' \n            ',(null as any));
    this._el_12 = import5.createRenderElement(this.renderer,this._el_9,'search-az',new import5.InlineArray4(4,'class','search-az','target','/catalogue'),(null as any));
    this._appEl_12 = new import3.AppElement(12,9,this,this._el_12);
    var compView_12:any = import43.viewFactory_SearchAZComponent0(this.viewUtils,this.injector(12),this._appEl_12);
    this._NgClass_12_4 = new import20.Wrapper_NgClass(this.parent.parentInjector.get(import27.IterableDiffers),this.parent.parentInjector.get(import28.KeyValueDiffers),new import9.ElementRef(this._el_12),this.renderer);
    this._SearchAZComponent_12_5 = new import43.Wrapper_SearchAZComponent(this.parent.parentInjector.get(import29.SearchService),new import9.ElementRef(this._el_12),this.parent.parentInjector.get(import11.UtilsService),this.parent.parentInjector.get(import15.ActivatedRoute),this.parent.parentInjector.get(import17.Router),this.parent.parentInjector.get(import30.ElasticSearchService));
    this._appEl_12.initComponent(this._SearchAZComponent_12_5.context,([] as any[]),compView_12);
    this._text_13 = this.renderer.createText((null as any),'\n            ',(null as any));
    compView_12.create(this._SearchAZComponent_12_5.context,([] as any[]),(null as any));
    this._text_14 = this.renderer.createText(this._el_9,'\n\n            ',(null as any));
    this._text_15 = this.renderer.createText(this._el_9,'\n            ',(null as any));
    this._text_16 = this.renderer.createText(this._el_9,'\n            ',(null as any));
    this._anchor_17 = this.renderer.createTemplateAnchor(this._el_9,(null as any));
    this._appEl_17 = new import3.AppElement(17,9,this,this._anchor_17);
    this._TemplateRef_17_5 = new import31.TemplateRef_(this._appEl_17,viewFactory_ContentRecordsComponent6);
    this._NgIf_17_6 = new import23.Wrapper_NgIf(this._appEl_17.vcRef,this._TemplateRef_17_5);
    this._text_18 = this.renderer.createText(this._el_9,'\n\n            ',(null as any));
    this._anchor_19 = this.renderer.createTemplateAnchor(this._el_9,(null as any));
    this._appEl_19 = new import3.AppElement(19,9,this,this._anchor_19);
    this._TemplateRef_19_5 = new import31.TemplateRef_(this._appEl_19,viewFactory_ContentRecordsComponent7);
    this._NgIf_19_6 = new import23.Wrapper_NgIf(this._appEl_19.vcRef,this._TemplateRef_19_5);
    this._text_20 = this.renderer.createText(this._el_9,'\n\n            ',(null as any));
    this._text_21 = this.renderer.createText(this._el_9,'\n            ',(null as any));
    this._anchor_22 = this.renderer.createTemplateAnchor(this._el_9,(null as any));
    this._appEl_22 = new import3.AppElement(22,9,this,this._anchor_22);
    this._TemplateRef_22_5 = new import31.TemplateRef_(this._appEl_22,viewFactory_ContentRecordsComponent8);
    this._NgIf_22_6 = new import23.Wrapper_NgIf(this._appEl_22.vcRef,this._TemplateRef_22_5);
    this._text_23 = this.renderer.createText(this._el_9,'\n\n          ',(null as any));
    this._text_24 = this.renderer.createText(this._el_3,'\n\n          ',(null as any));
    this._text_25 = this.renderer.createText(this._el_3,'\n\n        ',(null as any));
    this._text_26 = this.renderer.createText(this._el_0,'\n\n        ',(null as any));
    this._text_27 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._anchor_28 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_28 = new import3.AppElement(28,0,this,this._anchor_28);
    this._TemplateRef_28_5 = new import31.TemplateRef_(this._appEl_28,viewFactory_ContentRecordsComponent9);
    this._NgIf_28_6 = new import23.Wrapper_NgIf(this._appEl_28.vcRef,this._TemplateRef_28_5);
    this._text_29 = this.renderer.createText(this._el_0,'\n\n        ',(null as any));
    this._text_30 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._anchor_31 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_31 = new import3.AppElement(31,0,this,this._anchor_31);
    this._TemplateRef_31_5 = new import31.TemplateRef_(this._appEl_31,viewFactory_ContentRecordsComponent11);
    this._NgIf_31_6 = new import23.Wrapper_NgIf(this._appEl_31.vcRef,this._TemplateRef_31_5);
    this._text_32 = this.renderer.createText(this._el_0,'\n\n        ',(null as any));
    this._text_33 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._anchor_34 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_34 = new import3.AppElement(34,0,this,this._anchor_34);
    this._TemplateRef_34_5 = new import31.TemplateRef_(this._appEl_34,viewFactory_ContentRecordsComponent13);
    this._NgIf_34_6 = new import23.Wrapper_NgIf(this._appEl_34.vcRef,this._TemplateRef_34_5);
    this._text_35 = this.renderer.createText(this._el_0,'\n\n        ',(null as any));
    this._text_36 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._anchor_37 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_37 = new import3.AppElement(37,0,this,this._anchor_37);
    this._TemplateRef_37_5 = new import31.TemplateRef_(this._appEl_37,viewFactory_ContentRecordsComponent15);
    this._NgSwitchCase_37_6 = new import22.Wrapper_NgSwitchCase(this._appEl_37.vcRef,this._TemplateRef_37_5,(<_View_ContentRecordsComponent0>this.parent)._NgSwitch_47_3.context);
    this._text_38 = this.renderer.createText(this._el_0,'\n\n        ',(null as any));
    this._text_39 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._text_40 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._text_41 = this.renderer.createText(this._el_0,'\n      ',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._text_2,
      this._el_3,
      this._text_4,
      this._text_5,
      this._anchor_6,
      this._text_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._text_14,
      this._text_15,
      this._text_16,
      this._anchor_17,
      this._text_18,
      this._anchor_19,
      this._text_20,
      this._text_21,
      this._anchor_22,
      this._text_23,
      this._text_24,
      this._text_25,
      this._text_26,
      this._text_27,
      this._anchor_28,
      this._text_29,
      this._text_30,
      this._anchor_31,
      this._text_32,
      this._text_33,
      this._anchor_34,
      this._text_35,
      this._text_36,
      this._anchor_37,
      this._text_38,
      this._text_39,
      this._text_40,
      this._text_41
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import31.TemplateRef) && (6 === requestNodeIndex))) { return this._TemplateRef_6_5; }
    if (((token === import35.NgIf) && (6 === requestNodeIndex))) { return this._NgIf_6_6.context; }
    if (((token === import33.NgClass) && ((12 <= requestNodeIndex) && (requestNodeIndex <= 13)))) { return this._NgClass_12_4.context; }
    if (((token === import44.SearchAZComponent) && ((12 <= requestNodeIndex) && (requestNodeIndex <= 13)))) { return this._SearchAZComponent_12_5.context; }
    if (((token === import31.TemplateRef) && (17 === requestNodeIndex))) { return this._TemplateRef_17_5; }
    if (((token === import35.NgIf) && (17 === requestNodeIndex))) { return this._NgIf_17_6.context; }
    if (((token === import31.TemplateRef) && (19 === requestNodeIndex))) { return this._TemplateRef_19_5; }
    if (((token === import35.NgIf) && (19 === requestNodeIndex))) { return this._NgIf_19_6.context; }
    if (((token === import31.TemplateRef) && (22 === requestNodeIndex))) { return this._TemplateRef_22_5; }
    if (((token === import35.NgIf) && (22 === requestNodeIndex))) { return this._NgIf_22_6.context; }
    if (((token === import33.NgClass) && ((9 <= requestNodeIndex) && (requestNodeIndex <= 23)))) { return this._NgClass_9_3.context; }
    if (((token === import33.NgClass) && ((3 <= requestNodeIndex) && (requestNodeIndex <= 25)))) { return this._NgClass_3_3.context; }
    if (((token === import31.TemplateRef) && (28 === requestNodeIndex))) { return this._TemplateRef_28_5; }
    if (((token === import35.NgIf) && (28 === requestNodeIndex))) { return this._NgIf_28_6.context; }
    if (((token === import31.TemplateRef) && (31 === requestNodeIndex))) { return this._TemplateRef_31_5; }
    if (((token === import35.NgIf) && (31 === requestNodeIndex))) { return this._NgIf_31_6.context; }
    if (((token === import31.TemplateRef) && (34 === requestNodeIndex))) { return this._TemplateRef_34_5; }
    if (((token === import35.NgIf) && (34 === requestNodeIndex))) { return this._NgIf_34_6.context; }
    if (((token === import31.TemplateRef) && (37 === requestNodeIndex))) { return this._TemplateRef_37_5; }
    if (((token === import34.NgSwitchCase) && (37 === requestNodeIndex))) { return this._NgSwitchCase_37_6.context; }
    if (((token === import33.NgClass) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 41)))) { return this._NgClass_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = 'catalogue-content col-md-offset-1';
    this._NgClass_0_3.check_klass(currVal_0_0_0,throwOnChange,false);
    const currVal_0_0_1:any = this._map_72(this.parent.context.hasFilter,!this.parent.context.hasFilter);
    this._NgClass_0_3.check_ngClass(currVal_0_0_1,throwOnChange,false);
    this._NgClass_0_3.detectChangesInInputProps(this,this._el_0,throwOnChange);
    const currVal_3_0_0:any = 'shorting clearfix xs-no-margin col-xs-12';
    this._NgClass_3_3.check_klass(currVal_3_0_0,throwOnChange,false);
    const currVal_3_0_1:any = this._map_73(this.parent.context.hasFilter,!this.parent.context.hasFilter);
    this._NgClass_3_3.check_ngClass(currVal_3_0_1,throwOnChange,false);
    this._NgClass_3_3.detectChangesInInputProps(this,this._el_3,throwOnChange);
    const currVal_6_0_0:boolean = !this.parent.context.hasFilter;
    this._NgIf_6_6.check_ngIf(currVal_6_0_0,throwOnChange,false);
    this._NgIf_6_6.detectChangesInInputProps(this,this._anchor_6,throwOnChange);
    const currVal_9_0_0:any = 'search-tools-container col-xs-12 grid-nav';
    this._NgClass_9_3.check_klass(currVal_9_0_0,throwOnChange,false);
    const currVal_9_0_1:any = this._map_74(!this.parent.context.hasFilter);
    this._NgClass_9_3.check_ngClass(currVal_9_0_1,throwOnChange,false);
    this._NgClass_9_3.detectChangesInInputProps(this,this._el_9,throwOnChange);
    const currVal_12_0_0:any = 'search-az';
    this._NgClass_12_4.check_klass(currVal_12_0_0,throwOnChange,false);
    const currVal_12_0_1:any = this._map_75(!this.parent.context.hasFilter);
    this._NgClass_12_4.check_ngClass(currVal_12_0_1,throwOnChange,false);
    this._NgClass_12_4.detectChangesInInputProps(this,this._el_12,throwOnChange);
    const currVal_12_1_0:any = ((this.parent.context.intl.data == (null as any))? (null as any): this.parent.context.intl.data.COMMON.TAXONOMY);
    this._SearchAZComponent_12_5.check_labels(currVal_12_1_0,throwOnChange,false);
    const currVal_12_1_1:any = this.parent.context.currentLanguage;
    this._SearchAZComponent_12_5.check_language(currVal_12_1_1,throwOnChange,false);
    const currVal_12_1_2:any = ((this.parent.context.intl.data == (null as any))? (null as any): this.parent.context.intl.data.CATALOGUE.NEW_SEARCH)[this.parent.context.currentLanguage];
    this._SearchAZComponent_12_5.check_title(currVal_12_1_2,throwOnChange,false);
    const currVal_12_1_3:any = '/catalogue';
    this._SearchAZComponent_12_5.check_target(currVal_12_1_3,throwOnChange,false);
    this._SearchAZComponent_12_5.detectChangesInInputProps(this,this._el_12,throwOnChange);
    const currVal_17_0_0:any = (this.parent.context.entryType != 'special');
    this._NgIf_17_6.check_ngIf(currVal_17_0_0,throwOnChange,false);
    this._NgIf_17_6.detectChangesInInputProps(this,this._anchor_17,throwOnChange);
    const currVal_19_0_0:any = this.parent.context.hasFilter;
    this._NgIf_19_6.check_ngIf(currVal_19_0_0,throwOnChange,false);
    this._NgIf_19_6.detectChangesInInputProps(this,this._anchor_19,throwOnChange);
    const currVal_22_0_0:any = this.parent.context.hasFilter;
    this._NgIf_22_6.check_ngIf(currVal_22_0_0,throwOnChange,false);
    this._NgIf_22_6.detectChangesInInputProps(this,this._anchor_22,throwOnChange);
    const currVal_28_0_0:any = (((((this.parent.context.config.data == (null as any))? (null as any): this.parent.context.config.data.CATALOGUE.FEATURED) && this.parent.context.isFirstPage) && !this.parent.context.entryType) && !this.parent.context.hasFilter);
    this._NgIf_28_6.check_ngIf(currVal_28_0_0,throwOnChange,false);
    this._NgIf_28_6.detectChangesInInputProps(this,this._anchor_28,throwOnChange);
    const currVal_31_0_0:any = (this.parent.context.entryType != 'special');
    this._NgIf_31_6.check_ngIf(currVal_31_0_0,throwOnChange,false);
    this._NgIf_31_6.detectChangesInInputProps(this,this._anchor_31,throwOnChange);
    const currVal_34_0_0:any = (this.parent.context.entryType == 'special');
    this._NgIf_34_6.check_ngIf(currVal_34_0_0,throwOnChange,false);
    this._NgIf_34_6.detectChangesInInputProps(this,this._anchor_34,throwOnChange);
    const currVal_37_0_0:any = false;
    this._NgSwitchCase_37_6.check_ngSwitchCase(currVal_37_0_0,throwOnChange,false);
    this._NgSwitchCase_37_6.detectChangesInInputProps(this,this._anchor_37,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._NgClass_0_3.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this._NgClass_3_3.detectChangesInHostProps(this,this._el_3,throwOnChange);
    this._NgClass_9_3.detectChangesInHostProps(this,this._el_9,throwOnChange);
    this._NgClass_12_4.detectChangesInHostProps(this,this._el_12,throwOnChange);
    this._SearchAZComponent_12_5.detectChangesInHostProps(this,this._el_12,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentRecordsComponent4(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordsComponent4(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordsComponent5 extends import1.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import3.AppElement;
  _SearchComponent_0_4:import39.Wrapper_SearchComponent;
  _text_1:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordsComponent5,renderType_ContentRecordsComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'search',new import5.InlineArray8(6,'class','search-nofilter col-lg-3 col-md-4 col-sm-5 col-xs-12','scrollOnClick','#content-start','target','/catalogue'),(null as any));
    this._appEl_0 = new import3.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = import39.viewFactory_SearchComponent0(this.viewUtils,this.injector(0),this._appEl_0);
    this._SearchComponent_0_4 = new import39.Wrapper_SearchComponent(this.parent.parent.parentInjector.get(import11.UtilsService),this.parent.parent.parentInjector.get(import29.SearchService),this.parent.parent.parentInjector.get(import30.ElasticSearchService),this.parent.parent.parentInjector.get(import15.ActivatedRoute),this.parent.parent.parentInjector.get(import17.Router));
    this._appEl_0.initComponent(this._SearchComponent_0_4.context,([] as any[]),compView_0);
    this._text_1 = this.renderer.createText((null as any),'\n          ',(null as any));
    compView_0.create(this._SearchComponent_0_4.context,([] as any[]),(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import40.SearchComponent) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._SearchComponent_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = ((this.parent.parent.context.config.data == (null as any))? (null as any): this.parent.parent.context.config.data.CATALOGUE.SEARCH.SUGGESTIONS.ORDER);
    this._SearchComponent_0_4.check_order(currVal_0_0_0,throwOnChange,false);
    const currVal_0_0_1:any = '#content-start';
    this._SearchComponent_0_4.check_scrollOnClick(currVal_0_0_1,throwOnChange,false);
    const currVal_0_0_2:any = '/catalogue';
    this._SearchComponent_0_4.check_target(currVal_0_0_2,throwOnChange,false);
    const currVal_0_0_3:any = ((this.parent.parent.context.intl.data == (null as any))? (null as any): this.parent.parent.context.intl.data.CATALOGUE.SEARCH)[this.parent.parent.context.currentLanguage];
    this._SearchComponent_0_4.check_placeholder(currVal_0_0_3,throwOnChange,false);
    const currVal_0_0_4:any = this.parent.parent.context.currentLanguage;
    this._SearchComponent_0_4.check_language(currVal_0_0_4,throwOnChange,false);
    const currVal_0_0_5:any = ((this.parent.parent.context.intl.data == (null as any))? (null as any): this.parent.parent.context.intl.data.COMMON.TAXONOMY);
    this._SearchComponent_0_4.check_labels(currVal_0_0_5,throwOnChange,false);
    const currVal_0_0_6:any = true;
    this._SearchComponent_0_4.check_expand(currVal_0_0_6,throwOnChange,false);
    this._SearchComponent_0_4.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._SearchComponent_0_4.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentRecordsComponent5(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordsComponent5(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordsComponent6 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _text_5:any;
  /*private*/ _expr_6:any;
  _pipe_number_1_0:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordsComponent6,renderType_ContentRecordsComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_6 = import8.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'p',new import5.InlineArray2(2,'class','page-status text-uppercase pull-right xs-display-none'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n              ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'span',new import5.InlineArray2(2,'class',''),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n              ',(null as any));
    this._text_5 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._pipe_number_1_0 = import5.pureProxy2((<_View_ContentRecordsComponent0>this.parent.parent)._pipe_number_1.transform.bind((<_View_ContentRecordsComponent0>this.parent.parent)._pipe_number_1));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._text_5
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import8.ValueUnwrapper();
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_6:any = import5.interpolate(4,'\n                ',((this.parent.parent.context.pageSize <= (<_View_ContentRecordsComponent0>this.parent.parent)._SearchableContentsComponent_45_3.context.esContents['total'])? this.parent.parent.context.pageSize: (<_View_ContentRecordsComponent0>this.parent.parent)._SearchableContentsComponent_45_3.context.esContents['total']),' / ',(<_View_ContentRecordsComponent0>this.parent.parent)._SearchableContentsComponent_45_3.context.esContents['total'],' | \n                Page ',this.parent.parent.context.currentPage,' / ',valUnwrapper.unwrap(import5.castByValue(this._pipe_number_1_0,(<_View_ContentRecordsComponent0>this.parent.parent)._pipe_number_1.transform)(((<_View_ContentRecordsComponent0>this.parent.parent)._SearchableContentsComponent_45_3.context.esContents['total'] / this.parent.parent.context.pageSize),'1.0-0')),'\n              ');
    if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange,this._expr_6,currVal_6))) {
      this.renderer.setText(this._text_3,currVal_6);
      this._expr_6 = currVal_6;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentRecordsComponent6(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordsComponent6(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordsComponent7 extends import1.AppView<any> {
  _el_0:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordsComponent7,renderType_ContentRecordsComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'br',import5.EMPTY_INLINE_ARRAY,(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return (null as any);
  }
}
function viewFactory_ContentRecordsComponent7(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordsComponent7(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordsComponent8 extends import1.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import3.AppElement;
  _SearchFilterComponent_0_4:import45.Wrapper_SearchFilterComponent;
  _text_1:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordsComponent8,renderType_ContentRecordsComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'search-filters',new import5.InlineArray4(4,'class','search-filters','target','/catalogue'),(null as any));
    this._appEl_0 = new import3.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = import45.viewFactory_SearchFilterComponent0(this.viewUtils,this.injector(0),this._appEl_0);
    this._SearchFilterComponent_0_4 = new import45.Wrapper_SearchFilterComponent(this.parent.parent.parentInjector.get(import11.UtilsService),this.parent.parent.parentInjector.get(import17.Router),this.parent.parent.parentInjector.get(import15.ActivatedRoute),this.parent.parent.parentInjector.get(import30.ElasticSearchService));
    this._appEl_0.initComponent(this._SearchFilterComponent_0_4.context,([] as any[]),compView_0);
    this._text_1 = this.renderer.createText((null as any),'\n            ',(null as any));
    compView_0.create(this._SearchFilterComponent_0_4.context,([] as any[]),(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import46.SearchFilterComponent) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._SearchFilterComponent_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = (<_View_ContentRecordsComponent0>this.parent.parent)._SearchableContentsComponent_45_3.context.esQuery;
    this._SearchFilterComponent_0_4.check_esQuery(currVal_0_0_0,throwOnChange,false);
    const currVal_0_0_1:any = (<_View_ContentRecordsComponent0>this.parent.parent)._SearchableContentsComponent_45_3.context.esFilters;
    this._SearchFilterComponent_0_4.check_esFilters(currVal_0_0_1,throwOnChange,false);
    const currVal_0_0_2:any = ((this.parent.parent.context.intl.data == (null as any))? (null as any): this.parent.parent.context.intl.data.CATALOGUE.FILTERS)[this.parent.parent.context.currentLanguage];
    this._SearchFilterComponent_0_4.check_title(currVal_0_0_2,throwOnChange,false);
    const currVal_0_0_3:any = '/catalogue';
    this._SearchFilterComponent_0_4.check_target(currVal_0_0_3,throwOnChange,false);
    const currVal_0_0_4:any = ((this.parent.parent.context.intl.data == (null as any))? (null as any): this.parent.parent.context.intl.data.COMMON.TAXONOMY);
    this._SearchFilterComponent_0_4.check_labels(currVal_0_0_4,throwOnChange,false);
    const currVal_0_0_5:any = this.parent.parent.context.currentLanguage;
    this._SearchFilterComponent_0_4.check_language(currVal_0_0_5,throwOnChange,false);
    this._SearchFilterComponent_0_4.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._SearchFilterComponent_0_4.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentRecordsComponent8(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordsComponent8(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordsComponent9 extends import1.AppView<any> {
  _el_0:any;
  _ContentRecordsFeaturedComponent_0_3:import47.Wrapper_ContentRecordsFeaturedComponent;
  _text_1:any;
  _anchor_2:any;
  /*private*/ _appEl_2:import3.AppElement;
  _TemplateRef_2_5:any;
  _NgFor_2_6:import48.Wrapper_NgFor;
  _text_3:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordsComponent9,renderType_ContentRecordsComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'div',new import5.InlineArray4(4,'class','record-listing-featured record-listing','content-records-featured',''),(null as any));
    this._ContentRecordsFeaturedComponent_0_3 = new import47.Wrapper_ContentRecordsFeaturedComponent(this.parent.parent.parentInjector.get(import14.ContentService),this.parent.parent.parentInjector.get(import11.UtilsService),this.parent.parent.parentInjector.get(import15.ActivatedRoute),this.parent.parent.parentInjector.get(import17.Router),this.parent.parent.parentInjector.get(import30.ElasticSearchService));
    this._text_1 = this.renderer.createText(this._el_0,'\n          ',(null as any));
    this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_2 = new import3.AppElement(2,0,this,this._anchor_2);
    this._TemplateRef_2_5 = new import31.TemplateRef_(this._appEl_2,viewFactory_ContentRecordsComponent10);
    this._NgFor_2_6 = new import48.Wrapper_NgFor(this._appEl_2.vcRef,this._TemplateRef_2_5,this.parent.parent.parentInjector.get(import27.IterableDiffers),this.parent.parent.ref);
    this._text_3 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._anchor_2,
      this._text_3
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import31.TemplateRef) && (2 === requestNodeIndex))) { return this._TemplateRef_2_5; }
    if (((token === import49.NgFor) && (2 === requestNodeIndex))) { return this._NgFor_2_6.context; }
    if (((token === import50.ContentRecordsFeaturedComponent) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 3)))) { return this._ContentRecordsFeaturedComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._ContentRecordsFeaturedComponent_0_3.detectChangesInInputProps(this,this._el_0,throwOnChange);
    const currVal_2_0_0:any = this._ContentRecordsFeaturedComponent_0_3.context.dbContentsLimited(4);
    this._NgFor_2_6.check_ngForOf(currVal_2_0_0,throwOnChange,false);
    this._NgFor_2_6.detectChangesInInputProps(this,this._anchor_2,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._ContentRecordsFeaturedComponent_0_3.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentRecordsComponent9(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordsComponent9(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordsComponent10 extends import1.AppView<any> {
  _el_0:any;
  _NgClass_0_3:import20.Wrapper_NgClass;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _text_10:any;
  _text_11:any;
  _text_12:any;
  _el_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _el_17:any;
  _text_18:any;
  _text_19:any;
  _text_20:any;
  _map_22:any;
  /*private*/ _expr_23:any;
  /*private*/ _expr_24:any;
  _pipe_intl_0_6:any;
  /*private*/ _expr_26:any;
  _pipe_truncate_2_0:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordsComponent10,renderType_ContentRecordsComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._map_22 = import5.pureProxy1((p0:any):{[key: string]:any} => {
      return {'col-md-3 col-xs-6': p0};
    });
    this._expr_23 = import8.UNINITIALIZED;
    this._expr_24 = import8.UNINITIALIZED;
    this._expr_26 = import8.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'div',new import5.InlineArray2(2,'class','record-item'),(null as any));
    this._NgClass_0_3 = new import20.Wrapper_NgClass(this.parent.parent.parent.parentInjector.get(import27.IterableDiffers),this.parent.parent.parent.parentInjector.get(import28.KeyValueDiffers),new import9.ElementRef(this._el_0),this.renderer);
    this._text_1 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'div',new import5.InlineArray2(2,'class',''),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                  ',(null as any));
    this._el_4 = import5.createRenderElement(this.renderer,this._el_2,'a',new import5.InlineArray2(2,'class','pointer'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                    ',(null as any));
    this._el_6 = import5.createRenderElement(this.renderer,this._el_4,'img',new import5.InlineArray2(2,'alt',''),(null as any));
    this._text_7 = this.renderer.createText(this._el_4,'\n                    ',(null as any));
    this._el_8 = import5.createRenderElement(this.renderer,this._el_4,'span',new import5.InlineArray2(2,'class','image-tag'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'',(null as any));
    this._text_10 = this.renderer.createText(this._el_4,'\n                  ',(null as any));
    this._text_11 = this.renderer.createText(this._el_2,'\n                ',(null as any));
    this._text_12 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_13 = import5.createRenderElement(this.renderer,this._el_0,'div',new import5.InlineArray2(2,'class','record-desc'),(null as any));
    this._text_14 = this.renderer.createText(this._el_13,'\n                  ',(null as any));
    this._el_15 = import5.createRenderElement(this.renderer,this._el_13,'div',new import5.InlineArray2(2,'class','catalogue-record-title gray-text text-uppercase letter-spacing-2'),(null as any));
    this._text_16 = this.renderer.createText(this._el_15,'\n                      ',(null as any));
    this._el_17 = import5.createRenderElement(this.renderer,this._el_15,'a',new import5.InlineArray2(2,'class','pointer'),(null as any));
    this._text_18 = this.renderer.createText(this._el_17,'',(null as any));
    this._text_19 = this.renderer.createText(this._el_13,'\n                ',(null as any));
    this._text_20 = this.renderer.createText(this._el_0,'\n          ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_4,'click',this.eventHandler(this._handle_click_4_0.bind(this)));
    this._pipe_intl_0_6 = import5.pureProxy2((<_View_ContentRecordsComponent0>this.parent.parent.parent)._pipe_intl_0.transform.bind((<_View_ContentRecordsComponent0>this.parent.parent.parent)._pipe_intl_0));
    var disposable_1:Function = this.renderer.listen(this._el_17,'click',this.eventHandler(this._handle_click_17_0.bind(this)));
    this._pipe_truncate_2_0 = import5.pureProxy2((<_View_ContentRecordsComponent0>this.parent.parent.parent)._pipe_truncate_2.transform.bind((<_View_ContentRecordsComponent0>this.parent.parent.parent)._pipe_truncate_2));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._text_10,
      this._text_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._el_17,
      this._text_18,
      this._text_19,
      this._text_20
    ]
    ,[
      disposable_0,
      disposable_1
    ]
    ,([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import33.NgClass) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 20)))) { return this._NgClass_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import8.ValueUnwrapper();
    const currVal_0_0_0:any = 'record-item';
    this._NgClass_0_3.check_klass(currVal_0_0_0,throwOnChange,false);
    const currVal_0_0_1:any = this._map_22(!this.parent.parent.parent.context.hasFilter);
    this._NgClass_0_3.check_ngClass(currVal_0_0_1,throwOnChange,false);
    this._NgClass_0_3.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._NgClass_0_3.detectChangesInHostProps(this,this._el_0,throwOnChange);
    const currVal_23:any = import5.interpolate(1,'/data/covers/thumbs/',this.context.$implicit.cover.front,'');
    if (import5.checkBinding(throwOnChange,this._expr_23,currVal_23)) {
      this.renderer.setElementProperty(this._el_6,'src',this.viewUtils.sanitizer.sanitize(import51.SecurityContext.URL,currVal_23));
      this._expr_23 = currVal_23;
    }
    valUnwrapper.reset();
    const currVal_24:any = import5.interpolate(1,'',valUnwrapper.unwrap(import5.castByValue(this._pipe_intl_0_6,(<_View_ContentRecordsComponent0>this.parent.parent.parent)._pipe_intl_0.transform)(((this.parent.parent.parent.context.intl.data == (null as any))? (null as any): this.parent.parent.parent.context.intl.data.CATALOGUE.FEATURED),this.parent.parent.parent.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange,this._expr_24,currVal_24))) {
      this.renderer.setText(this._text_9,currVal_24);
      this._expr_24 = currVal_24;
    }
    valUnwrapper.reset();
    const currVal_26:any = import5.interpolate(1,'\n                        ',valUnwrapper.unwrap(import5.castByValue(this._pipe_truncate_2_0,(<_View_ContentRecordsComponent0>this.parent.parent.parent)._pipe_truncate_2.transform)(this.context.$implicit.title,((this.parent.parent.parent.context.config.data == (null as any))? (null as any): this.parent.parent.parent.context.config.data.CATALOGUE.RECORD_TITLE_TRUNCATE))),'');
    if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange,this._expr_26,currVal_26))) {
      this.renderer.setText(this._text_18,currVal_26);
      this._expr_26 = currVal_26;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_4_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_4_0:any = ((<any>this.parent.parent.parent.context.utils.lLink(this.context.$implicit.url,this.parent.parent.parent.context.currentLanguage)) !== false);
    return (true && pd_4_0);
  }
  private _handle_click_17_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_17_0:any = ((<any>this.parent.parent.parent.context.utils.lLink(this.context.$implicit.url,this.parent.parent.parent.context.currentLanguage)) !== false);
    return (true && pd_17_0);
  }
}
function viewFactory_ContentRecordsComponent10(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordsComponent10(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordsComponent11 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _anchor_2:any;
  /*private*/ _appEl_2:import3.AppElement;
  _TemplateRef_2_5:any;
  _NgFor_2_6:import48.Wrapper_NgFor;
  _text_3:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordsComponent11,renderType_ContentRecordsComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'div',new import5.InlineArray2(2,'class','record-listing'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n          ',(null as any));
    this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_2 = new import3.AppElement(2,0,this,this._anchor_2);
    this._TemplateRef_2_5 = new import31.TemplateRef_(this._appEl_2,viewFactory_ContentRecordsComponent12);
    this._NgFor_2_6 = new import48.Wrapper_NgFor(this._appEl_2.vcRef,this._TemplateRef_2_5,this.parent.parent.parentInjector.get(import27.IterableDiffers),this.parent.parent.ref);
    this._text_3 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._anchor_2,
      this._text_3
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import31.TemplateRef) && (2 === requestNodeIndex))) { return this._TemplateRef_2_5; }
    if (((token === import49.NgFor) && (2 === requestNodeIndex))) { return this._NgFor_2_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = (<_View_ContentRecordsComponent0>this.parent.parent)._SearchableContentsComponent_45_3.context.dbContents;
    this._NgFor_2_6.check_ngForOf(currVal_2_0_0,throwOnChange,false);
    this._NgFor_2_6.detectChangesInInputProps(this,this._anchor_2,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentRecordsComponent11(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordsComponent11(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordsComponent12 extends import1.AppView<any> {
  _el_0:any;
  _NgClass_0_3:import20.Wrapper_NgClass;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _text_6:any;
  _text_7:any;
  _el_8:any;
  _LazyLoadImageDirective_8_3:import52.Wrapper_LazyLoadImageDirective;
  _text_9:any;
  _text_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _el_14:any;
  _text_15:any;
  _el_16:any;
  _text_17:any;
  _text_18:any;
  _text_19:any;
  _map_22:any;
  /*private*/ _expr_23:any;
  /*private*/ _expr_24:any;
  _pipe_truncate_2_1:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordsComponent12,renderType_ContentRecordsComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._map_22 = import5.pureProxy2((p0:any,p1:any):{[key: string]:any} => {
      return {
        'col-md-4 col-sm-6 col-xs-5': p0,
        'col-md-3 col-sm-4 col-xs-6': p1
      }
      ;
    });
    this._expr_23 = import8.UNINITIALIZED;
    this._expr_24 = import8.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'div',new import5.InlineArray2(2,'class','record-item'),(null as any));
    this._NgClass_0_3 = new import20.Wrapper_NgClass(this.parent.parent.parent.parentInjector.get(import27.IterableDiffers),this.parent.parent.parent.parentInjector.get(import28.KeyValueDiffers),new import9.ElementRef(this._el_0),this.renderer);
    this._text_1 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'div',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                  ',(null as any));
    this._el_4 = import5.createRenderElement(this.renderer,this._el_2,'a',new import5.InlineArray2(2,'class','pointer'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                    ',(null as any));
    this._text_6 = this.renderer.createText(this._el_4,'\n                    ',(null as any));
    this._text_7 = this.renderer.createText(this._el_4,'\n                    ',(null as any));
    this._el_8 = import5.createRenderElement(this.renderer,this._el_4,'img',new import5.InlineArray2(2,'alt',''),(null as any));
    this._LazyLoadImageDirective_8_3 = new import52.Wrapper_LazyLoadImageDirective(new import9.ElementRef(this._el_8),this.parent.parent.parent.parentInjector.get(import53.NgZone));
    this._text_9 = this.renderer.createText(this._el_4,'\n\n                  ',(null as any));
    this._text_10 = this.renderer.createText(this._el_2,'\n                ',(null as any));
    this._text_11 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_12 = import5.createRenderElement(this.renderer,this._el_0,'div',new import5.InlineArray2(2,'class','record-desc'),(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'\n                  ',(null as any));
    this._el_14 = import5.createRenderElement(this.renderer,this._el_12,'div',new import5.InlineArray2(2,'class','catalogue-record-title gray-text text-uppercase letter-spacing-2'),(null as any));
    this._text_15 = this.renderer.createText(this._el_14,'\n                      ',(null as any));
    this._el_16 = import5.createRenderElement(this.renderer,this._el_14,'a',new import5.InlineArray2(2,'class','pointer'),(null as any));
    this._text_17 = this.renderer.createText(this._el_16,'',(null as any));
    this._text_18 = this.renderer.createText(this._el_12,'\n                ',(null as any));
    this._text_19 = this.renderer.createText(this._el_0,'\n          ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_4,'click',this.eventHandler(this._handle_click_4_0.bind(this)));
    var disposable_1:Function = this.renderer.listen(this._el_16,'click',this.eventHandler(this._handle_click_16_0.bind(this)));
    this._pipe_truncate_2_1 = import5.pureProxy2((<_View_ContentRecordsComponent0>this.parent.parent.parent)._pipe_truncate_2.transform.bind((<_View_ContentRecordsComponent0>this.parent.parent.parent)._pipe_truncate_2));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._text_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._el_14,
      this._text_15,
      this._el_16,
      this._text_17,
      this._text_18,
      this._text_19
    ]
    ,[
      disposable_0,
      disposable_1
    ]
    ,([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import54.LazyLoadImageDirective) && (8 === requestNodeIndex))) { return this._LazyLoadImageDirective_8_3.context; }
    if (((token === import33.NgClass) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 19)))) { return this._NgClass_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import8.ValueUnwrapper();
    const currVal_0_0_0:any = 'record-item';
    this._NgClass_0_3.check_klass(currVal_0_0_0,throwOnChange,false);
    const currVal_0_0_1:any = this._map_22(this.parent.parent.parent.context.hasFilter,!this.parent.parent.parent.context.hasFilter);
    this._NgClass_0_3.check_ngClass(currVal_0_0_1,throwOnChange,false);
    this._NgClass_0_3.detectChangesInInputProps(this,this._el_0,throwOnChange);
    const currVal_8_0_0:any = import5.interpolate(1,'/data/covers/thumbs/',this.context.$implicit.cover.front,'');
    this._LazyLoadImageDirective_8_3.check_lazyImage(currVal_8_0_0,throwOnChange,false);
    const currVal_8_0_1:any = import5.interpolate(1,'/data/covers/lazy/',this.context.$implicit.cover.front,'');
    this._LazyLoadImageDirective_8_3.check_defaultImage(currVal_8_0_1,throwOnChange,false);
    this._LazyLoadImageDirective_8_3.detectChangesInInputProps(this,this._el_8,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._LazyLoadImageDirective_8_3.context.ngAfterContentInit(); } }
    this._NgClass_0_3.detectChangesInHostProps(this,this._el_0,throwOnChange);
    const currVal_23:any = import5.interpolate(1,'/data/covers/thumbs/',this.context.$implicit.cover.front,'');
    if (import5.checkBinding(throwOnChange,this._expr_23,currVal_23)) {
      this.renderer.setElementProperty(this._el_8,'src',this.viewUtils.sanitizer.sanitize(import51.SecurityContext.URL,currVal_23));
      this._expr_23 = currVal_23;
    }
    this._LazyLoadImageDirective_8_3.detectChangesInHostProps(this,this._el_8,throwOnChange);
    valUnwrapper.reset();
    const currVal_24:any = import5.interpolate(1,'\n                        ',valUnwrapper.unwrap(import5.castByValue(this._pipe_truncate_2_1,(<_View_ContentRecordsComponent0>this.parent.parent.parent)._pipe_truncate_2.transform)(this.context.$implicit.title,((this.parent.parent.parent.context.config.data == (null as any))? (null as any): this.parent.parent.parent.context.config.data.CATALOGUE.RECORD_TITLE_TRUNCATE))),'');
    if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange,this._expr_24,currVal_24))) {
      this.renderer.setText(this._text_17,currVal_24);
      this._expr_24 = currVal_24;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  destroyInternal():void {
    this._LazyLoadImageDirective_8_3.context.ngOnDestroy();
  }
  private _handle_click_4_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_4_0:any = ((<any>this.parent.parent.parent.context.utils.lLink(this.context.$implicit.url,this.parent.parent.parent.context.currentLanguage)) !== false);
    return (true && pd_4_0);
  }
  private _handle_click_16_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_16_0:any = ((<any>this.parent.parent.parent.context.utils.lLink(this.context.$implicit.url,this.parent.parent.parent.context.currentLanguage)) !== false);
    return (true && pd_16_0);
  }
}
function viewFactory_ContentRecordsComponent12(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordsComponent12(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordsComponent13 extends import1.AppView<any> {
  _el_0:any;
  _ContentSpecialsComponent_0_3:import55.Wrapper_ContentSpecialsComponent;
  _text_1:any;
  _anchor_2:any;
  /*private*/ _appEl_2:import3.AppElement;
  _TemplateRef_2_5:any;
  _NgFor_2_6:import48.Wrapper_NgFor;
  _text_3:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordsComponent13,renderType_ContentRecordsComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'div',new import5.InlineArray4(4,'class','record-listing','content-specials',''),(null as any));
    this._ContentSpecialsComponent_0_3 = new import55.Wrapper_ContentSpecialsComponent(this.parent.parent.parentInjector.get(import14.ContentService),this.parent.parent.parentInjector.get(import11.UtilsService),this.parent.parent.parentInjector.get(import15.ActivatedRoute),this.parent.parent.parentInjector.get(import17.Router),this.parent.parent.parentInjector.get(import30.ElasticSearchService));
    this._text_1 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_2 = new import3.AppElement(2,0,this,this._anchor_2);
    this._TemplateRef_2_5 = new import31.TemplateRef_(this._appEl_2,viewFactory_ContentRecordsComponent14);
    this._NgFor_2_6 = new import48.Wrapper_NgFor(this._appEl_2.vcRef,this._TemplateRef_2_5,this.parent.parent.parentInjector.get(import27.IterableDiffers),this.parent.parent.ref);
    this._text_3 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._anchor_2,
      this._text_3
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import31.TemplateRef) && (2 === requestNodeIndex))) { return this._TemplateRef_2_5; }
    if (((token === import49.NgFor) && (2 === requestNodeIndex))) { return this._NgFor_2_6.context; }
    if (((token === import56.ContentSpecialsComponent) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 3)))) { return this._ContentSpecialsComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._ContentSpecialsComponent_0_3.detectChangesInInputProps(this,this._el_0,throwOnChange);
    const currVal_2_0_0:any = this._ContentSpecialsComponent_0_3.context.dbContents;
    this._NgFor_2_6.check_ngForOf(currVal_2_0_0,throwOnChange,false);
    this._NgFor_2_6.detectChangesInInputProps(this,this._anchor_2,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._ContentSpecialsComponent_0_3.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentRecordsComponent13(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordsComponent13(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordsComponent14 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _text_8:any;
  _el_9:any;
  _text_10:any;
  _el_11:any;
  _text_12:any;
  _el_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _el_17:any;
  _text_18:any;
  _text_19:any;
  _el_20:any;
  _text_21:any;
  _text_22:any;
  _el_23:any;
  _text_24:any;
  _text_25:any;
  _el_26:any;
  _text_27:any;
  _el_28:any;
  _text_29:any;
  _text_30:any;
  _text_31:any;
  _text_32:any;
  _text_33:any;
  /*private*/ _expr_34:any;
  /*private*/ _expr_35:any;
  /*private*/ _expr_36:any;
  /*private*/ _expr_37:any;
  _pipe_truncate_2_2:any;
  /*private*/ _expr_39:any;
  _pipe_intl_0_7:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordsComponent14,renderType_ContentRecordsComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_34 = import8.UNINITIALIZED;
    this._expr_35 = import8.UNINITIALIZED;
    this._expr_36 = import8.UNINITIALIZED;
    this._expr_37 = import8.UNINITIALIZED;
    this._expr_39 = import8.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'div',new import5.InlineArray2(2,'class','col-md-6 col-sm-6 xs-margin-bottom-ten'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'div',new import5.InlineArray2(2,'class','model-details clearfix xs-no-margin'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                    ',(null as any));
    this._el_4 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','text-center col-md-6 no-padding'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                      ',(null as any));
    this._el_6 = import5.createRenderElement(this.renderer,this._el_4,'img',new import5.InlineArray4(4,'alt','','class','pointer'),(null as any));
    this._text_7 = this.renderer.createText(this._el_4,'\n                    ',(null as any));
    this._text_8 = this.renderer.createText(this._el_2,'\n                    ',(null as any));
    this._el_9 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','col-md-6 no-padding'),(null as any));
    this._text_10 = this.renderer.createText(this._el_9,'\n                      ',(null as any));
    this._el_11 = import5.createRenderElement(this.renderer,this._el_9,'div',new import5.InlineArray2(2,'class','special-text model-details-text'),(null as any));
    this._text_12 = this.renderer.createText(this._el_11,'\n                          ',(null as any));
    this._el_13 = import5.createRenderElement(this.renderer,this._el_11,'div',new import5.InlineArray2(2,'class','separator-line bg-black no-margin-lr margin-ten'),(null as any));
    this._text_14 = this.renderer.createText(this._el_11,'\n                          ',(null as any));
    this._el_15 = import5.createRenderElement(this.renderer,this._el_11,'span',new import5.InlineArray2(2,'class','display-block clearfix xs-no-margin sm-display-none'),(null as any));
    this._text_16 = this.renderer.createText(this._el_11,'\n                          ',(null as any));
    this._el_17 = import5.createRenderElement(this.renderer,this._el_11,'span',new import5.InlineArray2(2,'class','text-uppercase font-weight-600 black-text letter-spacing-2'),(null as any));
    this._text_18 = this.renderer.createText(this._el_17,'',(null as any));
    this._text_19 = this.renderer.createText(this._el_11,'\n                          ',(null as any));
    this._el_20 = import5.createRenderElement(this.renderer,this._el_11,'span',new import5.InlineArray2(2,'class','text-uppercase text-small letter-spacing-2 margin-two display-block'),(null as any));
    this._text_21 = this.renderer.createText(this._el_20,'',(null as any));
    this._text_22 = this.renderer.createText(this._el_11,'\n                          ',(null as any));
    this._el_23 = import5.createRenderElement(this.renderer,this._el_11,'p',new import5.InlineArray2(2,'class','margin-ten xs-no-margin'),(null as any));
    this._text_24 = this.renderer.createText(this._el_23,'',(null as any));
    this._text_25 = this.renderer.createText(this._el_11,'\n                          ',(null as any));
    this._el_26 = import5.createRenderElement(this.renderer,this._el_11,'span',new import5.InlineArray2(2,'class','margin-five xs-no-margin display-block clearfix xs-no-margin'),(null as any));
    this._text_27 = this.renderer.createText(this._el_11,'\n                          ',(null as any));
    this._el_28 = import5.createRenderElement(this.renderer,this._el_11,'a',new import5.InlineArray2(2,'class','bottom-align-text highlight-button-dark btn btn-very-small no-margin pointer'),(null as any));
    this._text_29 = this.renderer.createText(this._el_28,'',(null as any));
    this._text_30 = this.renderer.createText(this._el_11,'\n                      ',(null as any));
    this._text_31 = this.renderer.createText(this._el_9,'\n                  ',(null as any));
    this._text_32 = this.renderer.createText(this._el_2,'\n                ',(null as any));
    this._text_33 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_6,'click',this.eventHandler(this._handle_click_6_0.bind(this)));
    this._pipe_truncate_2_2 = import5.pureProxy2((<_View_ContentRecordsComponent0>this.parent.parent.parent)._pipe_truncate_2.transform.bind((<_View_ContentRecordsComponent0>this.parent.parent.parent)._pipe_truncate_2));
    var disposable_1:Function = this.renderer.listen(this._el_28,'click',this.eventHandler(this._handle_click_28_0.bind(this)));
    this._pipe_intl_0_7 = import5.pureProxy2((<_View_ContentRecordsComponent0>this.parent.parent.parent)._pipe_intl_0.transform.bind((<_View_ContentRecordsComponent0>this.parent.parent.parent)._pipe_intl_0));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._el_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._el_17,
      this._text_18,
      this._text_19,
      this._el_20,
      this._text_21,
      this._text_22,
      this._el_23,
      this._text_24,
      this._text_25,
      this._el_26,
      this._text_27,
      this._el_28,
      this._text_29,
      this._text_30,
      this._text_31,
      this._text_32,
      this._text_33
    ]
    ,[
      disposable_0,
      disposable_1
    ]
    ,([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import8.ValueUnwrapper();
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_34:any = import5.interpolate(1,'',this.context.$implicit.image,'');
    if (import5.checkBinding(throwOnChange,this._expr_34,currVal_34)) {
      this.renderer.setElementProperty(this._el_6,'src',this.viewUtils.sanitizer.sanitize(import51.SecurityContext.URL,currVal_34));
      this._expr_34 = currVal_34;
    }
    const currVal_35:any = import5.interpolate(1,'',this.context.$implicit.title[this.parent.parent.parent.context.currentLanguage],'');
    if (import5.checkBinding(throwOnChange,this._expr_35,currVal_35)) {
      this.renderer.setText(this._text_18,currVal_35);
      this._expr_35 = currVal_35;
    }
    const currVal_36:any = import5.interpolate(1,'',this.context.$implicit.subtitle[this.parent.parent.parent.context.currentLanguage],'');
    if (import5.checkBinding(throwOnChange,this._expr_36,currVal_36)) {
      this.renderer.setText(this._text_21,currVal_36);
      this._expr_36 = currVal_36;
    }
    valUnwrapper.reset();
    const currVal_37:any = import5.interpolate(1,'',valUnwrapper.unwrap(import5.castByValue(this._pipe_truncate_2_2,(<_View_ContentRecordsComponent0>this.parent.parent.parent)._pipe_truncate_2.transform)(this.context.$implicit.content[this.parent.parent.parent.context.currentLanguage],((this.parent.parent.parent.context.config.data == (null as any))? (null as any): this.parent.parent.parent.context.config.data.SPECIAL.TITLE_TRUNCATE))),'');
    if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange,this._expr_37,currVal_37))) {
      this.renderer.setText(this._text_24,currVal_37);
      this._expr_37 = currVal_37;
    }
    valUnwrapper.reset();
    const currVal_39:any = import5.interpolate(1,'\n                            ',valUnwrapper.unwrap(import5.castByValue(this._pipe_intl_0_7,(<_View_ContentRecordsComponent0>this.parent.parent.parent)._pipe_intl_0.transform)(((this.parent.parent.parent.context.intl.data == (null as any))? (null as any): this.parent.parent.parent.context.intl.data.COMMON.SEE_MORE),this.parent.parent.parent.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange,this._expr_39,currVal_39))) {
      this.renderer.setText(this._text_29,currVal_39);
      this._expr_39 = currVal_39;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_6_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_6_0:any = ((<any>this.parent.parent.parent.context.utils.lLink(this.context.$implicit.url,this.parent.parent.parent.context.currentLanguage)) !== false);
    return (true && pd_6_0);
  }
  private _handle_click_28_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_28_0:any = ((<any>this.parent.parent.parent.context.utils.lLink(this.context.$implicit.url,this.parent.parent.parent.context.currentLanguage)) !== false);
    return (true && pd_28_0);
  }
}
function viewFactory_ContentRecordsComponent14(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordsComponent14(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordsComponent15 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  /*private*/ _appEl_2:import3.AppElement;
  _PaginationComponent_2_4:import57.Wrapper_PaginationComponent;
  _text_3:any;
  _text_4:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordsComponent15,renderType_ContentRecordsComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'div',new import5.InlineArray2(2,'class','pagination margin-two no-margin-bottom'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n          ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'ng-pagination',new import5.InlineArray16(10,'first-text','«','last-text','»','next-text','<img src=\'/data/images/arrow-next-small.png\'/>','previous-text','<img src=\'/data/images/arrow-pre-small.png\'/>','style','cursor: pointer'),(null as any));
    this._appEl_2 = new import3.AppElement(2,0,this,this._el_2);
    var compView_2:any = import57.viewFactory_PaginationComponent0(this.viewUtils,this.injector(2),this._appEl_2);
    this._PaginationComponent_2_4 = new import57.Wrapper_PaginationComponent();
    this._appEl_2.initComponent(this._PaginationComponent_2_4.context,([] as any[]),compView_2);
    this._text_3 = this.renderer.createText((null as any),'\n          ',(null as any));
    compView_2.create(this._PaginationComponent_2_4.context,([] as any[]),(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_2,'pageChange',this.eventHandler(this._handle_pageChange_2_0.bind(this)));
    const subscription_0:any = this._PaginationComponent_2_4.context.pageChange.subscribe(this.eventHandler(this._handle_pageChange_2_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4
    ]
    ,[disposable_0],[subscription_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import58.PaginationComponent) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 3)))) { return this._PaginationComponent_2_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = '<img src=\'/data/images/arrow-pre-small.png\'/>';
    this._PaginationComponent_2_4.check_previousText(currVal_2_0_0,throwOnChange,false);
    const currVal_2_0_1:any = '<img src=\'/data/images/arrow-next-small.png\'/>';
    this._PaginationComponent_2_4.check_nextText(currVal_2_0_1,throwOnChange,false);
    const currVal_2_0_2:any = '«';
    this._PaginationComponent_2_4.check_firstText(currVal_2_0_2,throwOnChange,false);
    const currVal_2_0_3:any = '»';
    this._PaginationComponent_2_4.check_lastText(currVal_2_0_3,throwOnChange,false);
    const currVal_2_0_4:any = (<_View_ContentRecordsComponent0>this.parent.parent)._SearchableContentsComponent_45_3.context.esContents['total'];
    this._PaginationComponent_2_4.check_totalItems(currVal_2_0_4,throwOnChange,false);
    const currVal_2_0_5:any = this.parent.parent.context.currentPage;
    this._PaginationComponent_2_4.check_currentPage(currVal_2_0_5,throwOnChange,false);
    const currVal_2_0_6:any = this.parent.parent.context.pageSize;
    this._PaginationComponent_2_4.check_pageSize(currVal_2_0_6,throwOnChange,false);
    this._PaginationComponent_2_4.detectChangesInInputProps(this,this._el_2,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._PaginationComponent_2_4.detectChangesInHostProps(this,this._el_2,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_pageChange_2_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_2_0:any = ((<any>this.parent.parent.context.onPageChange($event,'catalogue')) !== false);
    return (true && pd_2_0);
  }
}
function viewFactory_ContentRecordsComponent15(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordsComponent15(viewUtils,parentInjector,declarationEl);
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/front/content-records.component.ngfactory.ts